import React, {PropTypes} from 'react';
import classNames from 'classnames';

const VirtualEventItem = ({
  id,
  name,
  editing,
  onClick,
  onHideFromCaptain,
  status,
  checked
}) => (
  <div
    className={classNames(
      "list-group-item hover-highlight",
      {"highlight animated flipInX": editing}
    )}
  >
    <div
      className="list-group-item-inner-wrapper cursor-pointer"
      onClick={() => onClick(id)}
    >
      <h4 className="list-group-item-heading">
        <i className="fa fa-pencil" />
        {` `}
        {name}
      </h4>
      <label onClick={(e) => e.stopPropagation()}>Hide From Captains&nbsp;
        <input 
          type='checkbox'
          id={id}
          onChange={(event) => onHideFromCaptain(event)}
          checked={checked}
          disabled={status === 'Archived' || status === 'All Registrations Closed'}
        />
      </label>
    </div>
  </div>
);

VirtualEventItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  editing: PropTypes.bool,
  onClick: PropTypes.func,
  onHideFromCaptain: PropTypes.func
};

export default VirtualEventItem;



// WEBPACK FOOTER //
// ./src/features/tournament/events/VirtualEventItem.jsx